import { record } from '../utils/recorder';
import { BaseShapeMutationAPI } from './base-shape-mutation-api';
import type { IShapeDelta, ICTShapePropertiesDelta, ICTGroupShapePropertiesDelta } from '@tencent/slide-sdk-pb-model';
import type { IPictureData } from '../data';
import type { PictureDataModel } from '../model/picture-data-model';
import type { DeltaOf } from '../utils/delta';

export class PictureMutationAPI extends BaseShapeMutationAPI<PictureDataModel> {
    /**
     * 更新图片属性
     */
    @record()
    public updateProps({ spPr, nvPr, blipFill }: DeltaOf<IPictureData>) {
        const shapeDelta: Omit<IShapeDelta, 'spPr'> & {
            spPr?: ICTShapePropertiesDelta | ICTGroupShapePropertiesDelta | null;
        } = {};
        if (spPr) {
            shapeDelta.spPr = spPr;
        }
        if (nvPr) {
            shapeDelta.nvPr = {
                ...super.getCommonNonVisualPropsDelta(nvPr),
                picture: {
                    preferRelativeResize:
                        nvPr.preferRelativeResize === null
                            ? // 这里清空会还原默认值，preferRelativeResize 默认值是 true
                              true
                            : nvPr.preferRelativeResize,
                },
            };
        }
        if (blipFill) {
            shapeDelta.picture = {
                blipFill,
            };
        }
        return super.updateProps(shapeDelta);
    }
}
